import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TIndexAttributeData {
  id?: number;
  indexId?: number;
  indexTypeAttributeId?: number;
  attributeData: string;
  valid: boolean;
}

export interface IIndexAttributeData extends TIndexAttributeData {}

const IndexAttributeData = Model(
  (model: TIndexAttributeData): TIndexAttributeData => {
    const _value: TIndexAttributeData = Object.assign({}, model);
    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get indexId() {
        return _value.indexId;
      },
      set indexId(value) {
        _value.indexId = value;
      },
      get indexTypeAttributeId() {
        return _value.indexTypeAttributeId;
      },
      set indexTypeAttributeId(value) {
        _value.indexTypeAttributeId = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      },
      get attributeData() {
        return _value.attributeData;
      },
      set attributeData(value) {
        _value.attributeData = value;
      }
    };

    return ValidatableObject<TIndexAttributeData>(_model);
  }
);

export default IndexAttributeData;
